<template>
    <b-tooltip
        :custom-class="customClass ? `sys-tooltip ${customClass}` : 'sys-tooltip'"
        :target="target"
        :triggers="triggers"
        :placement="placement"
        :boundary-padding="boundaryPadding"
    >
        {{ text }}
        <slot />
    </b-tooltip>
</template>

<script>
    import { BTooltip } from "bootstrap-vue";

    export default {
        name: "TooltipNavbar",
        components: { BTooltip },
        props: {
            customClass: {
                type: String,
                default: ""
            },
            target: {
                type: String,
                required: true
            },
            triggers: {
                type: String,
                default: "hover"
            },
            placement: {
                type: String,
                default: "right"
            },
            text: {
                type: String
            },
            boundaryPadding: {
                type: String,
                default: "0"
            }
        }
    };
</script>

<style lang="scss">
    .sys-tooltip {
        //não adicione padding aqui e só estilize as classes especificas se possível
        margin: 0;
        .tooltip-inner {
            max-width: 100%;
            min-width: 1%;
            border-radius: 6px;
            overflow: hidden;
            padding: 8px 8px;
            text-align: left;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #fff;
            letter-spacing: 0.16px;
        }

        .arrow {
            &::before {
                border-top-color: #323232;
                border-bottom-color: #323232;
            }
        }
    }
</style>
